/**
 * Format a date as a short relative time string.
 * "Just now" / "5 min ago" / "2h ago" / "Yesterday" / "Mar 14"
 */
export function formatRelativeTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(d.getTime())) return '';

  const now = Date.now();
  const diffMs = now - d.getTime();
  const diffSec = Math.floor(diffMs / 1000);

  if (diffSec < 45) return 'Just now';

  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin} min ago`;

  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;

  // Check if it was literally "yesterday" (calendar day, not just 24h)
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const yday = new Date(today);
  yday.setDate(yday.getDate() - 1);

  const dStart = new Date(d);
  dStart.setHours(0, 0, 0, 0);

  if (dStart.getTime() === yday.getTime()) return 'Yesterday';

  // Older: show month + day (and year if different from current year)
  const sameYear = d.getFullYear() === new Date().getFullYear();
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    ...(sameYear ? {} : { year: 'numeric' }),
  });
}
